import React from 'react';
import PropTypes from 'prop-types';
require('./EmptyCart.scss');

const EmptyCart = () => (
  <div className="emptyCartContainer">
    <div className="emptyCartText">No items in the cart.</div>
  </div>
);

export default EmptyCart;
